/**
 * Asynchronously loads the component for JobShare
 */

import { lazyLoad } from 'utils/loadable';

export const JobShareHandler = lazyLoad(
  () => import('./index'),
  module => module.default,
);